/* eslint-disable import/prefer-default-export */
export const SHIPPING_RESTRICTIONS = {
  ca: 'Canada',
  domestic: 'Domestic',
  alcohol_restricted: 'Domestic Alcohol',
  fr: 'France',
  de: 'Germany',
  ormd_restricted: 'Hazardous',
  ie: 'Ireland',
  military: 'Military',
  hi_ak: 'Non-Continental',
  pr: 'Puerto Rico',
  uk: 'United Kingdom',
};
